<template>
  <div>
    <v-container grid-list-xl fluid>
      <header-title title="Registro"></header-title>
      <div v-if="convocatoria.id > 0">
        <!-- <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-text>
                Requisitos de postulación según <b>{{ convocatoria.cite }}</b>.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>   -->
        <v-row class="mb-1">
          <v-col cols="12" sm="8" class="offset-2"  v-for="(item, index) in modalidades" :key="index">
            <v-card v-if="item.sigla == 'A'">
              <!-- <v-card-title>{{ item.descripcion }}</v-card-title> -->
               <v-card-title>Requisito de Postulación</v-card-title>
              <v-card-text> 
                <!-- <div style="max-height:250px;overflow-y:scroll;overflow-x: hidden;">         -->
                  <div>   
                  <strong>Aspectos Generales:</strong>
                  <p class="mt-2" v-if="item.sigla == 'A'">
                    <ul>
                    <li>El Ministerio de Educación del Estado Plurinacional de Bolivia, en el marco de la Constitución Política del Estado, la Ley Nº 070 “Avelino Siñani Elizardo Pérez” y el Reglamento del Proceso de Admisión a las ESFM/UA Gestión 2026, convoca a los bachilleres que deseen formarse como maestros con el grado académico de Licenciatura, a postularse al Proceso de Admisión para la gestión 2026.</li>
                      <li>Todos los postulantes para las Escuelas Superiores de Formación de Maestros (ESFM) y Unidades Académicas (UA) deben rendir la Prueba Académica del proceso de admisión como requisito indispensable. Serán admitidos los postulantes que obtengan las mejores notas hasta completar los espacios disponibles por especialidad y por ESFM/UA</li>
                      <li><b>Postulantes de Naciones y Pueblos Indígena Originario Campesinos:</b>Los que se postulan por los Consejos Educativos de Pueblos Originarios (CEPOS), sólo se puede realizar en el departamento por el cual han sido postulados. </li>
                      <li><b>Postulantes con discapacidad:</b>Presentan carnet de discapacidad vigente otorgado por la Unidad Especializada Departamental (UED); Comité Departamental de Personas con Discapacidad (CODEPEDIS); Comité Nacional de Personas con Discapacidad (CONALPEDIS); Instituto Boliviano de la Ceguera (IBC), según corresponda. En los departamentos donde no se encuentre el Instituto Boliviano de la Ceguera (IBC), podrá certificar un Centro de Educación Especial legalmente establecido y acreditado para este efecto.</li>
                      <li>Los postulantes con discapacidad auditiva deben presentar el certificado gratuito de dominio de LENGUA DE SEÑAS BOLIVIANA (LSB), emitido por un Centro de Educación Especial legalmente establecido o Centro Integral Multisectorial o por la Federación Boliviana de Sordos (FEBOS), especificando el grado de discapacidad.</li>
                    </ul>
                  </p>
                  
                </div>
                <div v-if="item.sigla == 'A'">
                  <strong>Costo de Postulación:</strong>
                  <p class="mt-2">
                    <ul>
                      <li>Los postulantes deben hacer un pago por derecho de postulaciónde Bs. 108.00 (Ciento ocho 00/100 Bolivianos), los mismos deberán ser depositados a la <b>Cuenta Corriente Fiscal No. 10000004669343 "Ministerio de Educación - Recursos Propios" en el BANCO UNIÓN S.A.</b>. Los postulantes propuestos por los Consejos Educativos de Naciones y Pueblos Indígena Originario Campesinos y por las organizaciones de personas con discapacidad, están exentos de este pago.</li>
                    </ul>
                    
                  </p>
                </div>
                <div class="text-center">
                  <v-btn
                    type="submit"
                    color="primary"
                    @click="selectModalidad(item.id, item.sigla)"
                  >
                    Postular
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <notify-card :title="notify_title" :load="notify_load" process="el proceso de admisión"></notify-card>
      </div>
    </v-container>
  </div>
</template>

<script>
  import HeaderTitle from "@/components/HeaderTitle";
  import NotifyCard from "@/components/NotifyCard";
  import Service from "../utils/general";
  import axios from "axios";

  export default {
    name: "admision-inscripcion",
    components: {
      HeaderTitle,
      NotifyCard,
    },
    data: () => ({
      notify_title: "Cargando",
      notify_load: true,
      convocatoria: {
        id: null,
        cite: ""
      },
      modalidades: [],
    }),
    mounted() {
      this.getModalidades();
      Service.removeModality();
    },
    methods: {
      getModalidades() {
        this.notify_load = true;
        axios
          .get(
            Service.getUrlAPI() + "admision/modalidad",
            Service.getHeader()
          )
          .then(response => {
            this.convocatoria = response.data.convocatoria ? response.data.convocatoria : { id: null, cite: "" };
            this.modalidades = response.data.modalidades;
            this.notify_title = "Notificación";
            this.notify_load = false;
          })
          .catch(() => {
            this.notify_load = false;
            console.error("Parametros no encontrado");
          });
      },

      selectModalidad(id, sigla) {
        console.log(id,sigla);
        
        Service.setModality(this.convocatoria.id+'|'+id+'|'+sigla);
        if (sigla === 'A') {
          this.$router.push({ name: "admision-registro-a" });
        } else {
          this.$router.push({ name: "admision-registro-b" });
        }
      },
    },
  };
</script>